import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box } from "@mui/system";
import CropRotateIcon from "@mui/icons-material/CropRotate";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import { useMediaQuery } from "@mui/material";
// import Investtab from "./Investtab";
import { FormControlLabel } from "@mui/material";
import { Row, Col } from "reactstrap";

import {
  Container,
  FormControl,
  Input,
  InputAdornment,
  InputBase,
  InputLabel,
  Paper,
  TextField,
  Typography,
  Button,
} from "@mui/material";

import IconButton from "@mui/material/IconButton";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
// Nested List starts
import ListItemButton from "@mui/material/ListItemButton";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import List from "@mui/material/List";
import { Link, NavLink } from "react-router-dom";
// Nested List ends
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { AiOutlineCalculator } from "react-icons/ai";



import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { setHomeBanner } from "../../../redux/actions/adminDash_action.js";
import API from "../../../redux/url.js";
import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();


const HomeBanner = () => {

  const dispatch = useDispatch();

const [general, setgeneral] = useState(false);

const [generalid, setgeneralid] = useState(false);


  // const HomeBannerid = useSelector((state) => state.adminDashboard_red);
  // console.log("HomeBannerid");
  // console.log(HomeBannerid.HomeBanner.isSaved._id);


// console.log(myid);
 const [state, setState] = useState({
   tag: "",
   news: "",
   // image: null
 });

   const HomeBanner = useSelector(
     (state) => state.adminDashboard_red.HomeBanner
   );

   console.log("HomeBanner");
   console.log(HomeBanner);


useEffect(() => {
  // dispatch(getsocial());
  axios.get(API + "/getHomeBanner").then((res) => {
    console.log("getHomeBanner.data", res.data);
    setgeneral(res.data);
    console.log(res.data[0]._id);

    setgeneralid(res.data[0]._id);

    setState({
      tag: res.data[0].tag,
      news: res.data[0].news,
    });
  });
}, [HomeBanner]);
  

console.log("state.tagtag");
console.log(state.tag);

  

   const [statement, setStatement] = React.useState(false);
   const handleClickStatement = () => {
     setStatement(!statement);
   };

   const labls = {
     color: '#101924',
     flex: '1',
     marginLeft: '2px'
   };

const errmsg = {
  color: "red",
  position: "relative",
  top: "-11px",
};

const inputstyle = {
      padding: "3px 4px",
                display: "flex",
                alignItems: "center",
                width: "100%",
                border: "1px solid #bec2c7",
                borderRadius: "7px",
                marginBottom: "20px",
}



  const check = useMediaQuery("(max-Width:900px)");



  const [tagerr, settagerr] = useState("");
  const [newserr, setnewserr] = useState("");


 

   const onChangeHandler = (e) => {
     if (e.target.name == "image") {
       let val = e.target.files[0];
       setState({ ...state, [e.target.name]: val });
     } else {
       setState({ ...state, [e.target.name]: e.target.value });
     }
   };



   
  const validate = () => {
    
    console.log('validate called');
    let isvalid = true;

    if (
      state.tag.length < 5 ||
      state.tag.length > 50 ||
      state.tag.length == 0
    ) {
      isvalid = false;
      settagerr("Banner Left Tag needs to be 5 to 50 characters long");
      setnewserr("");
  
    } else if ( state.news.length < 5 || state.news.length > 750 || state.news.length == 0 ) {
      isvalid = false;
      settagerr("");
      setnewserr("News needs to be 5 to 750 characters long");
    } else {
     settagerr("");
     setnewserr("");
    }

    return isvalid;
  };




  const SubmitData = (e) => {
    e.preventDefault();

    let obj = {
      ...state,
      generalid,
      // description,
      // checkbox,
    };

    var isFormvalid = validate();
    console.log("isvalid", isFormvalid);
    window.scrollTo(0, 200);
    if (isFormvalid) {
      console.log(obj);
      dispatch(setHomeBanner(obj));
      // alert("ok");
    }

    // setState("");

    //  inputRef.current.focus();
  };

  return (
    <div className="content-wrapper">
      <div
        id="order_preview"
        className="wow fadeInUp content_box"
        style={{ visibility: "visible", animationName: "fadeInUp" }}
      >
        <Row classNameName="table-header">
          <Col xs="12" md="12">
            <h2 className="section-title" style={{ color: "black" }}>
              Edit Gerneral Settings{" "}
            </h2>
          </Col>
        </Row>
        <div className="row">
          <Row>
            <Col xs="12" md="9">
              {general ? (
                <div style={{ width: "50%" }}>
                  {general.map((item, index) => {
                    return (
                      <form>
                        <div className="form-group">
                          <label for="pwd">Banner Tag Line*</label>
                          <input
                            style={{ width: "100%" }}
                            type="text"
                            className="form-control"
                            required
                            name="tag"
                            onChange={onChangeHandler}
                            defaultValue={state.tag}
                          />
                          <center>
                            {tagerr ? <div style={errmsg}>{tagerr}</div> : null}
                          </center>
                        </div>

                        <div className="form-group">
                          <label for="pwd">Change Your News Line</label>

                          <input
                            style={{ width: "100%" }}
                            type="text"
                            className="form-control"
                            required
                            name="news"
                            onChange={onChangeHandler}
                            defaultValue={state.news}
                          />
                          <center>
                            {newserr ? (
                              <div style={errmsg}>{newserr}</div>
                            ) : null}
                          </center>
                        </div>

                        <div className="form-group">
                          <label for="pwd">Upload Banner Right Image </label>

                          <img
                            src={API + "/uploads/" + item.image}
                            alt={item.image}
                            height="100"
                            width="100"
                          />
                          <input
                            style={{ width: "100%" }}
                            type="file"
                            className="form-control"
                            name="image"
                            onChange={onChangeHandler}
                            required
                          />
                        </div>

                        {/* <div className="form-group featuredItems_out">
                    <input
                      type="checkbox"
                      className=""
                      required
                      name="isFeatured"
                      id="featured_item"
                      onChange={onChangeHandler}
                    />
                    <label for="featured_item">Featured</label>
                  </div> */}
                        <button
                          type="submit"
                          className="btn btn-default"
                          onClick={SubmitData}
                          style={{
                            marginTop: 10,
                            float: "right",
                            padding: "8px 16px",
                            fontSize: 16,
                          }}
                        >
                          Update Now
                        </button>
                      </form>
                    );
                  })}
                </div>
              ) : (
                <div>Loading...</div>
              )}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default HomeBanner;
